<template>
    <div class="container-fluid px-0">
        <!-- Large screens -->
        <h2 class="title fw-bold text-start d-none d-md-block">Admin</h2>

        <!-- Small screens -->
        <div class="d-md-none d-flex flex-column m-0 mb-3">
            <!-- Nav -->
            <div class="d-flex align-items-center justify-content-between small-nav">
                <!-- Back button -->
                <a v-load-page="'/'" v-ripple class="navbar-brand fw-bold fs-4 py-0 m-0 rounded-circle">
                    <i class="hoverable-icon bi-arrow-left"></i>
                </a>
                <!-- Title -->
                <p class="fs-5 fw-bold m-0">Admin</p>
                <!-- Menu toggler -->
                <i class="hoverable-icon bi-three-dots-vertical" v-ripple></i>
            </div>
        </div>

        <!-- Tab headings -->
        <Swiper id="mainTabsContainer" class="nav nav-tabs align-items-end border-0 in-page-swiper gap-medium" role="tablist" tag="ul">
            <template #content>
                <template v-for="(tab, index) in tabs">
                    <li class="nav-item align-items-center h-100" role="presentation" v-if="(tab.title === 'App Variables' && auth.is_admin) || (tab.title !== 'App Variables')">
                        <button class="position-relative nav-link h-100 p-0" :class="index == activeIndex ? 'active' : ''" data-bs-toggle="tab" :data-bs-target="`#tab-${index}-pane`" type="button" role="tab" @click="changeTab(tab.slug)" v-ripple>
	                        {{ tab.title }}
                        </button>
                    </li>
                </template>

            </template>
        </Swiper>

        <!-- Divider -->
        <div class="divider sm"></div>

        <!-- Tabs content -->
        <div class="tab-content mt-4">

            <!-- Tab container -->
            <template v-for="(tab, index) in tabs" :key="'admin_tab_'+index">
                <SingleAdminTab v-if="currentTab === tab.slug" :title="tab.title" :buttons="tab.buttons" :index="index">
                    <template v-slot:content="{ title }">
                        <Questions v-if="title === 'Questions'" @question-modal-closed="clickedTabButtonName = null"></Questions>
                        <Surveys v-if="title === 'Surveys'"></Surveys>
                        <Members v-if="title === 'Members'"></Members>
                        <Consents v-if="title === 'Consents'"></Consents>
                        <Company v-if="title === 'Company Pages'"></Company>
                        <AppVariables v-if="title === 'App Variables' && auth.is_admin"></AppVariables>
                    </template>
                </SingleAdminTab>
            </template>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from "vue";
import Swiper from "@/components/Swiper.vue";
import Questions from "@/views/Admin/Questions.vue";
import Surveys from '@/views/Admin/Surveys.vue';
import Members from '@/views/Admin/Members.vue';
import Consents from '@/views/Admin/Consents.vue';
import Company from '@/views/Admin/Company.vue';
import AppVariables from '@/views/Admin/AppVariables.vue';
import SingleAdminTab from '@/components/Admin/SingleAdminTab.vue';
import { useAuthStore } from "@/stores/auth-store";
import { provide } from 'vue';
import tab from "bootstrap/js/dist/tab";
import modal from "bootstrap/js/dist/modal";
import collapse from "bootstrap/js/dist/collapse";
import { useRoute, useRouter } from "vue-router";

const auth = useAuthStore();
const router = useRouter();
const route = useRoute();

const currentTab = ref("questions");
const clickedTabButtonName = ref(null);
const activeIndex = ref(0);

provide('clickedTabButtonName', clickedTabButtonName);

const tabs = [
    { title: "Questions", slug: 'questions', buttons: [{ title: 'Add New', class: 'btn-dark', callback: () => clickedTabButtonName.value = 'openQuestionModal' }] },
    { title: "Surveys", slug: 'surveys' },
    { title: "Members", slug: 'members' },
    { title: "Consents", slug: 'consents' },
    { title: "Company Pages", slug: 'company-pages' },
    { title: "App Variables", slug: 'app-variables' }
];

const changeTab = (slug) => {
	if(!slug) {
		currentTab.value = 'questions';
		return;
	}

	const queryParams = new URLSearchParams(window.location.search);
	if(!tabs.find(tab => tab.slug === slug)) {
		currentTab.value = 'questions';
		queryParams.delete('tab');
	}
	else{
		currentTab.value = slug;
		queryParams.set('tab', slug);
	}
	// window.history.replaceState({}, '', window.location.pathname + '?' + queryParams.toString());
	router.replace({path: route.path, query: { ...route.query, ...Object.fromEntries(queryParams) },});
	activeIndex.value = tabs.findIndex(t => t.slug === currentTab.value);
}

onMounted(() => {
	const queryParams = new URLSearchParams(window.location.search);
	const tab = queryParams.get('tab');
	if (tab) {
		changeTab(tab);
	}
})
</script>

<style lang="scss" scoped>
.title {
    margin-top: 3.4rem;
    margin-bottom: 1em;
}
</style>